import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;

/**
 * https://buefy.github.io/
 */
import Buefy from 'buefy';
import 'buefy/src/scss/buefy-build.scss';

/**
 * https://github.com/kazupon/vue-cli-plugin-i18n
 * http://kazupon.github.io/vue-i18n/
 */
import i18n from './i18n';

/**
 * https://github.com/vtimofeev/vue-check-view
 */
import checkView from 'vue-check-view';

/**
 * My custom cursor
 */
import CustomCursor from './plugins/CustomCursor';

/**
 * LazyLoad
 * https://github.com/hilongjw/vue-lazyload
 */
import VueLazyload from 'vue-lazyload';

Vue.use(Buefy);
Vue.use(checkView);
Vue.use(CustomCursor);
Vue.use(VueLazyload);

import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
  id: 'UA-135921039-1',
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
